/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Objet auquel une valeur de variable est rattachée. Le paramétrage d'un tunnel n'écrit que Tunnel ; les autres contextes sont produits par la souscription (devis, contrat…) ou par les franchises et plafonds d'une garantie.
 * @export
 */
export const TypeContextVariable = {
    Tunnel: 1,
    Devis: 2,
    Contrat: 3,
    Simulation: 4,
    Avenant: 5,
    GarantieTunnel: 6,
    GarantieDevis: 7,
    GarantieContrat: 8
} as const;
export type TypeContextVariable = typeof TypeContextVariable[keyof typeof TypeContextVariable];


export function instanceOfTypeContextVariable(value: any): boolean {
    for (const key in TypeContextVariable) {
        if (Object.prototype.hasOwnProperty.call(TypeContextVariable, key)) {
            if (TypeContextVariable[key as keyof typeof TypeContextVariable] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TypeContextVariableFromJSON(json: any): TypeContextVariable {
    return TypeContextVariableFromJSONTyped(json, false);
}

export function TypeContextVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeContextVariable {
    return json as TypeContextVariable;
}

export function TypeContextVariableToJSON(value?: TypeContextVariable | null): any {
    return value as any;
}

export function TypeContextVariableToJSONTyped(value: any, ignoreDiscriminator: boolean): TypeContextVariable {
    return value as TypeContextVariable;
}

